export default "__VITE_ASSET__25491537__"